import { render } from "./Repayments.vue?vue&type=template&id=9e497b46"
import script from "./Repayments.vue?vue&type=script&lang=js"
export * from "./Repayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__